import { render, staticRenderFns } from "./PostLikeButton.vue?vue&type=template&id=6f8affb5&scoped=true&"
import script from "./PostLikeButton.vue?vue&type=script&lang=js&"
export * from "./PostLikeButton.vue?vue&type=script&lang=js&"
import style0 from "./PostLikeButton.vue?vue&type=style&index=0&id=6f8affb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8affb5",
  null
  
)

export default component.exports